import { render } from "./ButtonMenu.vue?vue&type=template&id=0a054186"
import script from "./ButtonMenu.vue?vue&type=script&lang=js"
export * from "./ButtonMenu.vue?vue&type=script&lang=js"

import "./ButtonMenu.vue?vue&type=style&index=0&id=0a054186&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__